module.exports = __webpack_public_path__ + "static/logo_mlawa-ee7dd7b57781824d9e9d643dc37168f4.png";